
const CrudCodeValues = require("./CrudCodeValues");
module.exports = {
    BIT: "BIT",
    B: "B",
    GB: "GB",
    KB: "KB",
    MB: "MB",
    OC: "OC",
    PB: "PB",
    TB: "TB"
};
